import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { buttonSlot } from './slot.vanilla.mjs';

const ButtonSlot = forwardRef(
  ({ className: classNameFromProps, ...props }, forwardedRef) => {
    const className = classNames(buttonSlot, classNameFromProps);
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        "data-scope": "button",
        "data-part": "slot",
        className,
        ref: forwardedRef,
        ...props
      }
    );
  }
);

export { ButtonSlot };
//# sourceMappingURL=Slot.mjs.map
